import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import HomepageImage from '../assets/MOV-A-THON.png'; 
import PiechartImage from '../assets/piechart.png';

// --- THERMOMETER COMPONENT ---
const DonationProgress = ({ total, goal }) => {
    const progress = Math.min(100, (total / goal) * 100); 
    const totalDollars = (total / 100).toFixed(2);
    const goalDollars = (goal / 100).toFixed(2);

    return (
        <div 
          className="donation-progress-container" 
          style={{ width: '100%', maxWidth: '600px', margin: '1rem auto' }} // Reduced from 2rem
        >
            <h3 style={{color: '#283F94', marginBottom: '5px', fontSize: '1.2rem'}}>Fundraising Progress</h3>
            <div className="thermometer-bar-wrapper">
                <div 
                    className="thermometer-bar-fill" 
                    style={{ width: `${progress}%` }}
                >
                </div>
            </div>
            <p className="progress-text" style={{fontSize: '1rem', fontWeight: 'bold'}}>
                ${totalDollars} raised toward the goal of ${goalDollars} 
            </p>
        </div>
    );
};
// --- END THERMOMETER COMPONENT ---


const HomePage = () => {
  const navigate = useNavigate();
  const [totalDonated, setTotalDonated] = useState(0);
  const [fundraisingGoal, setFundraisingGoal] = useState(0);
  const [loadingProgress, setLoadingProgress] = useState(true);

  useEffect(() => {
    fetch('https://server-ojqx.onrender.com/api/donations/progress')
        .then(res => res.json())
        .then(data => {
            setTotalDonated(data.totalDonated);
            setFundraisingGoal(data.goal);
            setLoadingProgress(false);
        })
        .catch(err => {
            console.error('Error fetching donation progress:', err);
            setLoadingProgress(false);
        });
  }, []);

  return (
    <div className="homepage" style={{ padding: '6px 0 6px 0' }}>
      <h1 style={{ marginBottom: '0px', marginTop: '0' }}>
        Welcome to the Manorhaven Elementary School MOVE-A-THON
      </h1>

      {/* <div style={{ lineHeight: '1.4' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: '#0050a0', margin: 0 }}>
          Event Date: November 14th
        </h2>
        <p style={{ 
            fontSize: '1.25rem', 
            fontWeight: '500', 
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            columnGap: '0.5em',
            margin: '0.25rem 0 0 0'
          }}>
          <span style={{ display: 'inline-block' }}>K-2nd: 8:45-9:45am</span>
          <span style={{ display: 'inline-block' }}>3rd-5th: 10:00-11:00am</span>
        </p>
        <p style={{ fontSize: '1.1rem', fontWeight: '400', fontStyle: 'italic', margin: '0.25rem 0 0 0' }}>
          Rain Date: November 17th
        </p>
      </div> */}

      <img
        src={HomepageImage}
        alt="Manorhaven"
        style={{
          maxHeight: '500px',
          width: '100%',
          height: 'auto',
          objectFit: 'contain',
          marginTop: '-20px',
          marginBottom: '-10px'
        }}
      />

      <button
        className="donate-button"
        style={{padding: '16px 32px', fontSize: '1.25rem' }} // Reduced margins
        onClick={() => navigate('/donate')}
      >
        Donate Now
      </button>

      {!loadingProgress && fundraisingGoal > 0 && (
        <DonationProgress total={totalDonated} goal={fundraisingGoal} />
      )}

      <section style={{textAlign: 'left' }}> {/* Reduced from 2rem */}
        <h2 style={{ color: '#283F94', marginBottom: '1rem' }}>What is a MOVE-A-THON?</h2>
        <p>
          The Manorhaven MOVE-A-THON is an outdoor school wide event that gets kids moving in different ways as we raise critical funds through community and school support.
          During the event and in the weeks leading up to it, each class will have an opportunity to learn and experience new ways to get active and move their bodies through dance, stretching, yoga, and running.
        </p>
      </section>

      <section style={{textAlign: 'left' }}> {/* Reduced from 2rem */}
        <h2 style={{ color: '#283F94', marginBottom: '1rem' }}>How do your donations help?</h2>
        <p>
        Manorhaven Elementary School is proud to receive support from the PTA to fund critical resources and enrichment opportunities to support student achievement. Money raised from PTA-sponsored events goes directly to academic/cultural programs, clubs, recess and other equipment, and special family events. None of this would be possible without the generosity of Manorhaven families. This year, we are hoping to raise more money than ever before to continue the school beautification efforts we started last year to update the look and feel of our building. Our children will benefit from knowing their place of learning is valued and feel greater pride in their school.
        </p>
      </section>
      
      <img
        src={PiechartImage}
        alt="piechart"
        style={{
          maxHeight: '500px',
          width: '100%',
          height: 'auto',
          objectFit: 'contain',
          marginBottom: '1rem'
        }}
      />
    </div>
  );
};

export default HomePage;
